import React from "react";
import {QuadralLoaderProvider} from '@quadral/quadral-component-common/dist/components/loader/LoaderContext';
import QuadralButton from '@quadral/quadral-component-common/dist/components/button';
import QuadralModal from '@quadral/quadral-component-common/dist/components/modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPen } from "@fortawesome/free-solid-svg-icons";

export default function AddNewDocumentModal ({open, setOpen, ...props}) {

    async function uploadFiles(){
        if (props.isAssignation) {
            props.confirmAssignation({force: true, rotatedFiles: props.rotatedFiles});
            props.setIsAssignation(false);
        } else {
            props.uploadFiles({force: true});
        }
        setOpen(false);
    }

    function retractUploadedFiles(){
        if(props.isAssignation){
            props.deleteUploadedDocuments();
        }
        setOpen(false);
    }
    
    return (
    <>
        <QuadralLoaderProvider/>
        {open && (
            <QuadralModal
                title='Type de document incorrect'
                icon={<FontAwesomeIcon icon={faUserPen}/>}
                open={open}
                setOpen={setOpen}
                noButton
                action={
                    <>
                        <QuadralButton size="medium" color="error" variant="outlined"
                                        onClick={() => retractUploadedFiles()}>
                            Annuler
                        </QuadralButton>
                        <QuadralButton size="medium" color="success" variant="outlined"
                                        onClick={() => uploadFiles()}>
                            Ajouter
                        </QuadralButton>
                    </>
                }
            >
                    <p>Le service Vialink indique que le type de document ne correspond pas à celui attendu. </p>
                    <p>Vous pouvez essayer avec un autre fichier ou conserver celui-ci. Dans ce cas, Vialink n’extraira pas de données.</p>
            </QuadralModal>
        )}
    </>
  );
}